import Cookies from 'js-cookie';
import { TRACKING_USER_PARAMS_COOKIE } from '../constants';
import type { TrackingParams } from '../types';

export const getTrackingUserParamsCookie = (): TrackingParams | undefined => {
  const raw = Cookies.get(TRACKING_USER_PARAMS_COOKIE);

  if (!raw) return;

  try {
    const parsed = JSON.parse(raw);

    return parsed && typeof parsed === 'object' ? parsed : undefined;
  } catch {
    return;
  }
};
